module.exports = __webpack_public_path__ + "img/DG-browse-vehicles-default-chevy.30a1026c.png";